<template>
	<div id="top" class="container">
		<Html :lang="locale" translate="no" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Meta name="google" content="notranslate" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<navigation />

		<slot />

		<footers />
		<pop-up
			v-if="page && defaults[locale].website.popupContent"
			:image-webp="defaults[locale].website.popupImageWebp"
			:image="defaults[locale].website.popupImage"
			:content="defaults[locale].website.popupContent"
		/>
		<cookie-consent v-if="defaults[locale].cookieConsent.published" :item="defaults[locale].cookieConsent" />

		<to-top />
		<book-button type="fixedmobile" class="button button-cta reserve-now right">
			<font-awesome-icon icon="fa-light fa-calendar-days" size="1x" />
			<span>{{ $t('bookNow') }}</span>
		</book-button>

		<conversion-triggers :notifications="page && page.conversiontriggers" />
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

await fetchDefaults();
await fetchPage();

useClockBookingEngine();

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.hotelName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.hotelName || '',
	});

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@type': 'Hotel',
					'@id': `${config.public.siteUrl}#hotel`,
					image: website.structuredImage,
					url: config.public.siteUrl,
					name: website.hotelName,
					logo: `${config.public.siteUrl}/images/logo.png`,
					telephone: website.phone,
					email: website.email,
					address: {
						'@type': 'PostalAddress',
						streetAddress: `${website.street} ${website.number}, ${website.city}`,
						postalCode: website.postalCode,
					},
				}),
			},
		],
	});
}
</script>
